










































































import { FormsApi, RequestNewProductCommand } from "@/api";
import stateMixin from "@/mixins/state";

export default {
  data() {
    return {
      stopDateMenu: null,
      valid: true,
      fields: {
        department: "",
        stopDate: "",
        reason: ""
      },
      requiredFields: ["stopDate"],
      rules: {
        department: [(v: string) => !!v || "Naam van de afdeling is verplicht"],
        reason: [(v: string) => !!v || "Reden stopzetten afdeling is verplicht"]
      }
    };
  },
  mixins: [stateMixin],
  methods: {
    submit: async function() {
      if (this.valid) {
        this.setState(this.states.LOADING);
        const api = new FormsApi();
        try {
          const result = await api.formsRequestStopDepartment({
            ...this.fields
          });
          this.setState(this.states.COMPLETED);

          (this.$refs.form as HTMLFormElement).reset();
        } catch {
          this.setState(this.states.ERROR);
        }
      }
    }
  },
  computed: {
    stopDateRules() {
      if (this.requiredFields && this.requiredFields.indexOf("stopDate") > -1) {
        return [v => !!v || "Stopdatum is verplicht"];
      }
      return [];
    }
  }
};
